import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';
import { ConditionCell } from './ConditionCell';
import { AttributeCell } from './AttributeCell';
import { InspectionRerunWarning } from './InspectionRerunWarning';

interface CctvInspectedCellProps {
	value: boolean | null | undefined;
	rerunNeeded?: boolean;
}

// true = inspected (check), false = not inspected (dash, "Not inspected"),
// null = not applicable / unscored (dash, "No value").
export const CctvInspectedCell = ({
	value,
	rerunNeeded = false,
}: CctvInspectedCellProps) => {
	const { t } = useGlobalization();
	let content;
	if (value === true) {
		// The check icon is aria-hidden, so label it here for screen readers.
		content = (
			<span role="img" aria-label={t('Inspected')}>
				<ConditionCell condition="1" />
			</span>
		);
	} else if (value === false) {
		content = <ConditionCell condition="0" showNotInspected />;
	} else {
		content = <AttributeCell value={null} />;
	}
	return (
		<span style={{ display: 'inline-flex', alignItems: 'center' }}>
			{content}
			{rerunNeeded && <InspectionRerunWarning />}
		</span>
	);
};
